import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useStateSelector } from 'hooks';
import { fetchBuildings } from 'store/buildings/actions';
import { getBuildings } from 'store/buildings/selectors';

import PageLayout from 'layouts/PageLayout';

import { BuildingsDetails } from 'components';

const Buildings = () => {
  const dispatch = useDispatch();
  const { cooperativeId, ...rest } = useStateSelector((state) => ({
    buildings: getBuildings(state),
    loading: state.buildings.loading,
    cooperativeId: state.settings.current_cooperative,
  }));

  useEffect(() => {
    dispatch(fetchBuildings());
  }, [dispatch, cooperativeId]);

  return (
    <PageLayout>
      <BuildingsDetails {...rest} />
    </PageLayout>
  );
};

export default Buildings;
